import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useApiGet } from '../../utils/httpClientTs';
import { getDocumentViewLatest } from '../../endpoints/documents';

/**
 * Handles /library/document/:id/latest by loading the latest view
 * and redirecting to /library/:id/view/:versionId.
 */
const DocumentViewLatest: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { data, isLoading, error } = useApiGet(
    ['document-view-latest', id!],
    () => getDocumentViewLatest(id!),
    { enabled: !!id }
  );

  if (!id) return <Navigate to="/library" replace />;
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="40vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  if (error || !data?.version_id) {
    return <Navigate to="/library" replace />;
  }
  return <Navigate to={`/library/${id}/view/${data.version_id}`} replace />;
};

export default DocumentViewLatest;
